import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AiRequestUtilsService } from 'src/app/api/services/ai-request-utils.service';
import { ApiService } from 'src/app/api/services/api.service';
import { environment } from 'src/environments/environment';

export interface GenerateLayoutRequest {
  component: string;
  prompt: string;
  layoutHtml?: string;
}

export interface GeneratedLayoutData {
  html: string;
  usedAttributes: string[];
}

export type GenerateLayoutResponse =
  | { type: 'layout_generate'; data: GeneratedLayoutData; creditsUsed: number }
  | { type: 'no_credits'; data: string; creditsUsed: 0 };

@Injectable({ providedIn: 'root' })
export class LayoutAiApiService extends ApiService<GenerateLayoutResponse> {
  protected override APIUrl =
    environment.AI_SERVICE_URL + this.getResourceUrl();

  constructor(
    protected httpClient: HttpClient,
    private aiRequestUtils: AiRequestUtilsService,
  ) {
    super(httpClient);
  }

  override getResourceUrl(): string {
    return '/api/v1/layouts';
  }

  generateLayout(
    input: GenerateLayoutRequest,
  ): Promise<GenerateLayoutResponse> {
    const { headers, body } = this.aiRequestUtils.buildCall('', {
      includeEmail: true,
    });

    body.payload = {
      ...(body.payload as Record<string, unknown>),
      component: input.component,
      prompt: input.prompt,
      ...(input.layoutHtml ? { layoutHtml: input.layoutHtml } : {}),
    };

    return firstValueFrom(
      super.requestWithHeadersAsObservable(
        '',
        'POST',
        'generate',
        headers,
        undefined,
        body,
      ),
    );
  }
}
